import { Checkbox } from "antd";
import CustomInput from "../../../Common/CustomInput";
import { Controller, useFormContext } from "react-hook-form";
import OpenTextQuestionItem from "./OpenTextQuestionItem";
import MultipleChoiceQuestionItem from "./MultipleChoiceQuestionItem";
import { RatingQuestionItem } from "./RatingQuestionItem";
import { NSPQuestionItem } from "./NPSQuestionItem";
import FileInput from "../../../Common/FileInput";
import TextAreaEditor from "../../../Common/TextAreaEditor";
import GridChoiceQuestionItem from "./GridChoiceQuestionItem";

export const QuestionsListItem = ({
    question,
    questionIndex,
    questionName,
}) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <div
            style={{
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <Controller
                control={control}
                name={`${questionName}.headline`}
                render={({ field }) => (
                    <CustomInput
                        errors={errors}
                        label="Question *"
                        {...field}
                    />
                )}
            />
            <Controller
                control={control}
                name={`${questionName}.subheader`}
                render={({ field }) => (
                    <TextAreaEditor
                        errors={errors}
                        label="Description"
                        {...field}
                    />
                )}
            />
            <Controller
                control={control}
                name={`${questionName}.image`}
                render={({ field }) => (
                    <FileInput errors={errors} label="Image" {...field} />
                )}
            />
            <Controller
                control={control}
                name={`${questionName}.required`}
                render={({ field }) => (
                    <Checkbox checked={!!field.value} {...field}>
                        Required
                    </Checkbox>
                )}
            />
            {question.type === "openText" && (
                <OpenTextQuestionItem
                    questionName={questionName}
                    questionIndex={questionIndex}
                />
            )}
            {(question.type === "multipleChoiceSingle" ||
                question.type === "multipleChoiceMulti") && (
                <MultipleChoiceQuestionItem
                    questionIndex={questionIndex}
                    questionName={questionName}
                />
            )}
            {question.type === "rating" && (
                <RatingQuestionItem questionName={questionName} />
            )}
            {question.type === "nps" && (
                <NSPQuestionItem questionName={questionName} />
            )}
            {(question.type === "gridChoiceSingle" ||
                question.type === "gridChoiceMulti") && (
                <GridChoiceQuestionItem questionName={questionName} />
            )}
        </div>
    );
};
